module.exports = __webpack_public_path__ + "static/media/help1.a6334548.png";